@if (gotDgProperties) {
  <app-grid-view #gridView
    [apiPath]="dgApiPath"
    [dgActionColumn]="dgActionColumn"
    [dgColumns]="dgColumns"
    [dgPopup]="dgPopup"
    [dgProperties]="dgProperties"
    (addButtonClick)="gridAddButtonClick($event)"
    (deleteButtonClick)="gridDeleteButtonClick($event)"
    (editButtonClick)="gridEditButtonClick($event)"
    (rowClick)="gridRowClick($event)"
  >
  </app-grid-view>
}
